// Module
var code = "<grid-filter-switch-select identifier=\"eventsAlertReceiversGrid\"\n                           label=\"Select All\"\n                           action=\"$ctrl.actionSelect\">\n</grid-filter-switch-select>\n";
// Exports
module.exports = code;